/**
 * Single re-export point for every icon used in the app. Swapping icon sets
 * later is a change to this one file.
 *
 * All icons render as inline <svg> (tree-shaken, ~1KB each) — there is no icon
 * webfont. Every icon must be decorative (`aria-hidden`) and paired with text.
 */
import {
  ArrowRight,
  BadgeCheck,
  Check,
  ChevronDown,
  Clock,
  Code2,
  Compass,
  Cpu,
  Dumbbell,
  Flag,
  Globe,
  Link2,
  LogIn,
  LogOut,
  type LucideIcon,
  Music,
  Package,
  Palette,
  Plane,
  Plus,
  Search,
  Sparkles,
  Store,
  Tag,
  UserPlus,
  X,
} from 'lucide-react'

import type { ListingType } from '@/lib/types/listing'

export {
  ArrowRight,
  BadgeCheck,
  Check,
  ChevronDown,
  Clock,
  Compass,
  Flag,
  Globe,
  Link2,
  LogIn,
  LogOut,
  Package,
  Plus,
  Search,
  Sparkles,
  UserPlus,
  X,
}
export type { LucideIcon }

const CATEGORY_ICONS: Record<string, LucideIcon> = {
  Electronics: Cpu,
  Software: Code2,
  'Health & Wellness': Dumbbell,
  Design: Palette,
  'Music & Audio': Music,
  Travel: Plane,
}

/** Icon for a listing's category, with a sensible fallback. */
export function iconForCategory(category: string | null): LucideIcon {
  if (category === null) return Store
  return CATEGORY_ICONS[category] ?? Tag
}

/** Which accent a listing type is drawn in. */
export function accentForType(type: ListingType): 'primary' | 'secondary' {
  return type === 'referral' ? 'primary' : 'secondary'
}

/** CTA copy + icon for claiming a listing. Claim POSTs then opens the destination. */
export const CLAIM_ACTION: { label: string; icon: LucideIcon } = {
  label: 'Claim',
  icon: Link2,
}
